(() => {
  if (typeof __webpack_require__ !== 'undefined') {
    var oldGetScript = __webpack_require__.u;
    var oldLoadScript = __webpack_require__.e;
    var queryMap = {};
    var countMap = {};
    var getRetryDelay = function () {
      return 1000;
    };
    __webpack_require__.u = function (chunkId) {
      var result = oldGetScript(chunkId);
      return (
        result +
        (queryMap.hasOwnProperty(chunkId) ? '?' + queryMap[chunkId] : '')
      );
    };
    __webpack_require__.e = function (chunkId) {
      var result = oldLoadScript(chunkId);
      return result.catch(function (error) {
        var retries = countMap.hasOwnProperty(chunkId) ? countMap[chunkId] : 50;
        if (retries < 1) {
          var realSrc = oldGetScript(chunkId);
          error.message =
            'Loading chunk ' +
            chunkId +
            ' failed after 50 retries.\n(' +
            realSrc +
            ')';
          error.request = realSrc;
          var div = document.createElement('div');
          div.innerHTML =
            '    <div style="z-index: 99999; position: fixed; top: 40%; left: 50%; transform: translate(-50%, 0px); text-align: center;">      <div style="text-align: center;font-size: 24px; font-weight: 700; margin: 20px;">        Whoops, something went wrong...      </div>      <button        style="padding: 10px 20px; font-size: 20px; text-align: center; color: white; border: none; outline: none; cursor: pointer; text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25); background: black; border-bottom: 2px solid #565a59; box-shadow: inset 0 -2px #808786;"        onclick="window.location.reload()">        Try again      </button>   </div>  ';
          document.body.appendChild(div);
          throw error;
        }
        return new Promise(function (resolve) {
          var retryAttempt = 50 - retries + 1;
          setTimeout(function () {
            var retryAttemptString = '&retry-attempt=' + retryAttempt;
            var cacheBust = (function () {
              return Date.now();
            })();
            +retryAttemptString;
            queryMap[chunkId] = cacheBust;
            countMap[chunkId] = retries - 1;
            resolve(__webpack_require__.e(chunkId));
          }, getRetryDelay(retryAttempt));
        });
      });
    };
  }
})();
